import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useBilling } from '@/features/settings/hooks';

export function SubscriptionCard() {
  const billing = useBilling();

  if (billing.isLoading) {
    return <p className="text-sm text-(--color-fg-muted)">Carregando plano…</p>;
  }

  if (!billing.data) {
    return <p className="text-sm text-(--color-error)">Não foi possível carregar o plano.</p>;
  }

  const { plan, subscription, features } = billing.data;
  const activeFeatures = Object.entries(features)
    .filter(([, v]) => v)
    .map(([k]) => k);

  return (
    <Card>
      <div className="flex flex-col gap-3">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-semibold">Plano atual</h3>
            <p className="text-sm text-(--color-fg-muted)">
              {plan.name} · status{' '}
              <span className="font-medium text-(--color-fg)">{subscription.status}</span>
            </p>
          </div>
          <span className="rounded-md bg-(--color-surface-elevated) px-2 py-1 text-xs font-medium text-(--color-accent)">
            {plan.code}
          </span>
        </div>

        {plan.code === 'FREE_BETA' && (
          <p className="rounded-md bg-(--color-surface-elevated) p-3 text-sm text-(--color-fg-muted)">
            Gratuito durante o beta — todas as funcionalidades liberadas enquanto
            validamos o produto com médicos plantonistas.
          </p>
        )}

        <div>
          <h4 className="mb-1 text-sm font-medium">Recursos liberados</h4>
          {activeFeatures.length > 0 ? (
            <ul className="flex flex-wrap gap-1.5">
              {activeFeatures.map((f) => (
                <li
                  key={f}
                  className="rounded-md border border-(--color-border) px-2 py-0.5 text-xs text-(--color-fg-muted)"
                >
                  {f}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-(--color-fg-muted)">Nenhum recurso configurado.</p>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-2 pt-2">
          <Button variant="outline" disabled title="Disponível quando a monetização for ativada">
            Gerenciar cobrança
          </Button>
          <span className="text-xs text-(--color-fg-muted)">
            Disponível quando a monetização for ativada.
          </span>
        </div>
      </div>
    </Card>
  );
}
